export * from './objekte.component';
export * from './objekte.component.module';